import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  inject,
} from "@angular/core";
import { Accounts } from "../../interfaces/accounts";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { StorageService } from "@tae/services";
import { TaggingService } from "src/app/services/tagging.service";

@Component({
    selector: "app-accounts-list",
    templateUrl: "./accounts-list.component.html",
    styleUrls: ["./accounts-list.component.scss"],
    standalone: false
})
export class AccountsListComponent implements OnInit {
  public data: any;

  @Input() accounts: Accounts[];

  @Input() names: string[];

  @Output() selected: EventEmitter<Accounts> = new EventEmitter();

  public idItemCard: string = null;

  storageService = inject(StorageService);
  taggingService = inject(TaggingService);

  public buildDetailAccount(_account: Accounts): string {
    const { cardType, cardNumber } = _account.card;
    const { accountNumber } = _account.account;
    if (cardType === "TDC") {
      return `${cardType} ${cardNumber.slice(0, 4)}**${cardNumber.slice(-4)}`;
    }
    return `CTA ${accountNumber.slice(0, 2)}**${accountNumber.slice(-4)}`;
  }

  public selectAccount(account: Accounts): void {
    const nameAccount = this._sanitizeString(account?.account?.product?.productName);
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "elige_cuenta_de_origen",
      etiqueta: nameAccount,
      canalBanco: "supermovil",
      url: "recarga_celular/elige_cuenta_de_origen",
      userID: "",
    };

    this.taggingService.setEvent(action);

    this.idItemCard = account?.card?.cardNumber;
    this.selected.emit(account);
    if (this.data?.selected) {
      this.data.selected(account);
    }
  }

  private _sanitizeString(input: string): string {
    if (input == null) return 'seleccion_tarjeta';
    const str = String(input);
    const withoutAccents = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return withoutAccents
      .replace(/\s+/g, '_')
      .replace(/[^A-Za-z0-9_-]/g, '')
      .toLowerCase();
  }
  

  ngOnInit(): void {
    if (this.data) {
      this.accounts = this.data?.accounts;
      this.names = this.data?.title;
    }
    const pageView: PageViewInferface = {
      url: "recarga_celular/elige_cuenta_de_origen",
      titulo: "recarga_celular|elige_cuenta_de_origen",
      canalBanco: "supermovil",
      subsection1: "recarga_celular",
      versionApp: "",
      userId: "",
      entorno: this.storageService.get("ENV"),
      event: "PageView",
    };

    this.taggingService.setPageView(pageView);
  }
}
